import { Heart, MessageCircle, Users, User } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";

type Tab = {
  key: "likes" | "social" | "messages" | "profile";
  label: string;
  to: string;
  icon: (props: { className?: string }) => JSX.Element;
  isActive: (pathname: string) => boolean;
};

const TABS: Tab[] = [
  {
    key: "likes",
    label: "Beğeniler",
    to: "/likes",
    icon: ({ className }) => <Heart className={className} />,
    isActive: (pathname) => pathname === "/likes",
  },
  {
    key: "social",
    label: "Keşif",
    to: "/",
    icon: ({ className }) => <Users className={className} />,
    isActive: (pathname) => pathname === "/" || pathname === "/karma",
  },
  {
    key: "messages",
    label: "Mesajlar",
    to: "/messages",
    icon: ({ className }) => <MessageCircle className={className} />,
    isActive: (pathname) => pathname === "/messages",
  },
  {
    key: "profile",
    label: "Profil",
    to: "/profile",
    icon: ({ className }) => <User className={className} />,
    isActive: (pathname) =>
      pathname === "/profile" ||
      pathname.startsWith("/karma/me") ||
      pathname.startsWith("/karma/cember") ||
      pathname.startsWith("/karma/u/"),
  },
];

export function BottomTabBar({ className }: { className?: string }) {
  const { pathname } = useLocation();

  return (
    <nav
      className={cn(
        "fixed inset-x-0 bottom-0 z-50 border-t bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70",
        className,
      )}
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 0.5rem)" }}
      aria-label="Alt menü"
    >
      <div className="mx-auto flex max-w-md items-stretch justify-between px-6 pt-2">
        {TABS.map((tab) => {
          const active = tab.isActive(pathname);
          return (
            <Link
              key={tab.key}
              to={tab.to}
              className={cn(
                "flex w-1/4 flex-col items-center gap-1 rounded-2xl px-2 py-2 text-xs transition-colors",
                active ? "text-primary" : "text-muted-foreground hover:text-foreground",
              )}
              aria-current={active ? "page" : undefined}
            >
              <tab.icon className={cn("h-6 w-6", active ? "fill-primary" : "")} />
              <span className={cn("leading-none", active ? "font-medium" : "")}>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
